const centerRouter = () => {
    return [
        // {
        //     path: 'centerOrigin',
        //     name: 'centerOrigin',
        //     component: () => import(/* webpackChunkName: "center" */'../../modules/center/index.vue')
        //     // component: () => import(/* webpackChunkName: "center" */'./index-v.vue')
        // },
        {
            path: 'center/my/:name',
            name: 'centerMy',
            component: () => import(/* webpackChunkName: "center" */'../../modules/center/index.vue')
        }, {
            path: 'center/subordinate',
            name: 'centerDir',
            component: () => import(/* webpackChunkName: "center" */'../../modules/center/index.vue')
        }
    ];
};
export default centerRouter;
